import React, {useState} from "react";
import './sdCheck.scss';

function SDCheck (props) {
    let cn = ['main'];
    const [check, setCheck] = useState(props.value ?? false);

    function changeState () {
        if (props.changeState) props.changeState(props.data, !check);
        setCheck(check => !check);
    }

    return (
        <div className="mainCheck" onClick={() => changeState()}>
            <div className={`main ${check ? 'checked' : 'check'}`} ></div>
            <div className={`label ${props.type === 'todo' && check ? 'donelabel' : ''}`}>
                { props.label }
                { props.type === 'todo' ? <div className={`todo ${check ? 'done' : ''}`}></div> : '' }
            </div>
        </div>
    )
}

export default SDCheck;